if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ChillyPup: desktop gallery arrows and fit-to-screen */
(function () {
  if (window.cpGalleryArrows) return;
  window.cpGalleryArrows = true;
  var css = '@media screen and (min-width: 990px){' +
    '.product--thumbnail_slider media-gallery slider-component[id^="GalleryViewer"],.product--thumbnail_slider media-gallery .thumbnail-slider{max-width:min(100%, calc(100vh - 26rem));margin-left:auto;margin-right:auto}' +
    '.product--thumbnail_slider media-gallery slider-component[id^="GalleryViewer"]{position:relative}' +
    '.cp-gal-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:4.4rem;height:4.4rem;border-radius:50%;border:0;background:rgba(255,255,255,.92);box-shadow:0 2px 8px rgba(0,0,0,.15);color:#1E2620;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s ease}' +
    '.cp-gal-arrow:hover{background:#fff}.cp-gal-arrow svg{width:1.4rem;height:1.4rem}' +
    '.cp-gal-arrow--prev{left:1.2rem}.cp-gal-arrow--prev svg{transform:rotate(90deg)}' +
    '.cp-gal-arrow--next{right:1.2rem}.cp-gal-arrow--next svg{transform:rotate(-90deg)}}' +
    '@media screen and (max-width: 989px){.cp-gal-arrow{display:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var caret = '<svg viewBox="0 0 10 6" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';
  function init() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.dataset.cpArrows) return;
      var viewer = g.querySelector('slider-component[id^="GalleryViewer"]');
      if (!viewer || g.querySelectorAll('.thumbnail-list button.thumbnail').length < 2) return;
      g.dataset.cpArrows = '1';
      function go(step) {
        var list = Array.prototype.filter.call(g.querySelectorAll('.thumbnail-list button.thumbnail'), function (b) { return b.offsetParent !== null; });
        if (list.length < 2) return;
        var i = list.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        if (i < 0) i = 0;
        list[(i + step + list.length) % list.length].click();
      }
      ['prev', 'next'].forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cp-gal-arrow cp-gal-arrow--' + d;
        b.setAttribute('aria-label', d === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = caret;
        b.addEventListener('click', function (e) { e.preventDefault(); go(d === 'prev' ? -1 : 1); });
        viewer.appendChild(b);
      });
      var x0 = null;
      viewer.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      viewer.addEventListener('touchend', function (e) {
        if (x0 === null || window.innerWidth < 990) { x0 = null; return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        x0 = null;
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
